document.addEventListener('DOMContentLoaded', function () {
const lists = document.querySelectorAll(".collection-list");
  if (!lists.length) return;
  lists.forEach(list => {
    const items = Array.from(list.querySelectorAll(".collection-list__item"));
    items.sort((a, b) => {
      const textA = (a.getAttribute("alphabetical_order") || "")
        .trim()
        .toLowerCase();
      const textB = (b.getAttribute("alphabetical_order") || "")
        .trim()
        .toLowerCase();
      return textA.localeCompare(textB);
    });
    items.forEach(item => list.appendChild(item));
  });
  
const OFFSET = 100;
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener("click", function (e) {
      const id = this.getAttribute("href").substring(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        OFFSET;
      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
    });
  });
(function () {
  var path = window.location.pathname.replace(/\/$/, "");
  if (path === "/collections" || path === "/products") {
    window.location.replace("/");
  }
})();
});